document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const megaMenus = document.querySelectorAll('.menu-item-has-mega-dropdown');
    let activeMenuItem = null;

    const setHeaderMegaState = (isActive) => {
        if (!header) {
            return;
        }

        header.classList.toggle('header--mega-active', isActive);
    };

    const closeMegaMenu = () => {
        if (!activeMenuItem) {
            setHeaderMegaState(false);
            return;
        }

        activeMenuItem.classList.remove('is-open');

        const activeTrigger = Array.from(activeMenuItem.children).find((child) => child.tagName === 'A');

        if (activeTrigger) {
            activeTrigger.setAttribute('aria-expanded', 'false');
        }

        activeMenuItem = null;
        setHeaderMegaState(false);
    };

    const openMegaMenu = (menuItem, topLevelTrigger) => {
        if (activeMenuItem && activeMenuItem !== menuItem) {
            closeMegaMenu();
        }

        activeMenuItem = menuItem;
        activeMenuItem.classList.add('is-open');
        setHeaderMegaState(true);

        if (topLevelTrigger) {
            topLevelTrigger.setAttribute('aria-expanded', 'true');
        }
    };

    megaMenus.forEach((menuItem) => {
        const topLevelTrigger = Array.from(menuItem.children).find((child) => child.tagName === 'A');
        const triggers = menuItem.querySelectorAll('.header__mega-item[data-mega-image-id]');
        const panels = menuItem.querySelectorAll('.header__mega-image-wrap[data-mega-image-panel]');

        if (!triggers.length || !panels.length) {
            return;
        }

        if (topLevelTrigger) {
            topLevelTrigger.setAttribute('aria-haspopup', 'true');
            topLevelTrigger.setAttribute('aria-expanded', 'false');
        }

        const setActiveImage = (imageId) => {
            if (!imageId) {
                return;
            }

            triggers.forEach((trigger) => {
                const isActive = trigger.dataset.megaImageId === imageId;
                trigger.classList.toggle('is-active', isActive);
            });

            panels.forEach((panel) => {
                const isActive = panel.dataset.megaImagePanel === imageId;
                panel.classList.toggle('is-active', isActive);
            });
        };

        triggers.forEach((trigger) => {
            const imageId = trigger.dataset.megaImageId;

            trigger.addEventListener('mouseenter', function() {
                setActiveImage(imageId);
            });

            trigger.addEventListener('focus', function() {
                setActiveImage(imageId);
            });
        });

        menuItem.addEventListener('mouseenter', function() {
            openMegaMenu(menuItem, topLevelTrigger);
        });

        menuItem.addEventListener('mouseleave', function() {
            if (activeMenuItem === menuItem) {
                closeMegaMenu();
            }
        });

        if (topLevelTrigger) {
            topLevelTrigger.addEventListener('focus', function() {
                openMegaMenu(menuItem, topLevelTrigger);
            });
        }

        menuItem.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                closeMegaMenu();
            }
        });
    });

    document.addEventListener('click', function(event) {
        if (!activeMenuItem) {
            return;
        }

        if (activeMenuItem.contains(event.target)) {
            return;
        }

        closeMegaMenu();
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeMegaMenu();
        }
    });
});
